import {
  Outlet,
  // useLocation,
  //  useNavigate, useParams
} from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { PageTabs } from "@/components/Tabs";

function AccountLayout() {
  // const { t } = useTranslation();
  // const { app_id = "" } = useParams();
  // const location = useLocation();
  // const navigate = useNavigate();
  // const onSettlements = location.pathname.includes("/account/settlements");

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      {/* <div className="mx-5 mt-5">
        <PageTabs
          activeKey={onSettlements ? "settlements" : "profile"}
          onChange={(key) => {
            navigate(
              key === "settlements"
                ? `/apps/${app_id}/account/settlements`
                : `/apps/${app_id}/account`,
            );
          }}
          items={[
            { key: "profile", label: t("nav.developerInfo") },
            { key: "settlements", label: t("settlements.title") },
          ]}
        />
      </div> */}
      <Outlet />
    </div>
  );
}

export default AccountLayout;
